import { useEffect, useState } from 'react';
import { Palette } from 'lucide-react';
import { applyTheme, readStoredTheme, THEMES, ThemeId } from './registry';

export function ThemePicker() {
  const [theme, setTheme] = useState<ThemeId>(() => readStoredTheme());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return (
    <div className="fixed bottom-6 end-6 z-40">
      {open && (
        <div className="mb-3 bg-paper border border-linen shadow-xl rounded-md overflow-hidden min-w-[260px]">
          <div className="px-4 py-3 border-b border-linen bg-ivory">
            <div className="editorial-label text-ink">— Choisir un thème</div>
          </div>
          {THEMES.map((t) => (
            <button
              key={t.id}
              onClick={() => {
                setTheme(t.id);
                setOpen(false);
              }}
              className={`w-full text-start px-4 py-3 transition-colors hover:bg-ivory ${
                theme === t.id ? 'bg-ivory' : ''
              }`}
            >
              <div className="flex items-center justify-between gap-3">
                <span className="font-display text-base">{t.label}</span>
                {theme === t.id && <span className="editorial-number text-base">✓</span>}
              </div>
              <div className="font-body text-xs text-ink-soft mt-1">{t.description}</div>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className="bg-ink text-ivory rounded-full px-5 py-3 shadow-lg hover:bg-brass-dark transition-colors inline-flex items-center gap-2"
      >
        <Palette className="w-4 h-4" aria-hidden="true" />
        <span className="editorial-label text-ivory">Thème</span>
      </button>
    </div>
  );
}
